import globalColors from './globalColors';

const secondary = {
  light: '#546E7A',
  main: '#37474F',
  dark: '#2f3d44'
};

const primary1 = {
  light: '#E4EFFA',
  main: '#ADCCED',
  dark: '#1D4D81'
};

const primary = {
  light: '#CCD6ED',
  main: '#6382C9',
  dark: '#6382C9'
};

const disabledColor = '#FFF';
const disabledTextColor = 'rgba(0, 0, 0, 0.26)';

const defaultText = {
  color: '#333333',
  background: '#FFF'
};

const hoverColor = '#E6E6E6';

const lightBlue = {
  palette: {
    ...globalColors,
    type: 'light',
    secondary,
    primary,
    navBarInput: '#AFC0C9',
    externalCodeColor: '#B0BFE3',
    background: {
      default: '#F2F2F2'
    },
    header: secondary.light,
    scrollColor: secondary.light,
    navDrawer: {
      backGround: secondary.main,
      itemHover: secondary.light,
      dividerColor: secondary.dark,
      itemSelected: secondary.dark,
      itemSelectedBorder: '#adcced',
      scrollColor: '#adcced'
    },
    sideBar: {
      itemActive: {
        background: secondary.light,
        color: '#fff'
      },
      itemHover: {
        background: hoverColor
      },
      toggleButton: '#FFF',
      toggleButtonColor: '#1D4D81'
    },
    table: {
      green: {
        lighter: '#effaef',
        light: '#d2f0d2',
        main: '#aae1aa',
        dark: '#66bb6a'
      }
    },
    ddSelector: {
      ...defaultText,
      item: '#F7F7F7',
      itemHover: hoverColor,
      itemSelected: secondary.light,
      borderColor: 'rgba(0, 0, 0, 0.23)'
    },
    hoverBackgroundColor: 'rgba(0, 0, 0, 0.04)',
    disabled: disabledColor,
    disabledText: disabledTextColor,
    input: {
      ...defaultText,
      '&:disabled': {
        background: disabledColor
      }
    },
    text: defaultText,
    subTextColor: '#b6b6b6',
    icon: 'rgba(0, 0, 0, 0.54)',
    modalHeaderColor: secondary.main,
    plannerJumbotron: disabledColor,
    reactTable: {
      ...defaultText,
      oddRow: '#E6E6E6',
      filterBorderColor: 'rgba(0, 0, 0, 0.1)'
    },
    listItem: {
      secondaryText: '#B0BFE3'
    },
    muiTable: {
      header: {
        backgroundColor: primary.light,
        color: '#40545E'
      }
    },
    paperBorderColor: 'rgba(0, 0, 0, 0.12)',
    reportTable: {
      container: {
        height: '100%',
        background: '#e2e7eb',
        borderLeft: '1px solid #546e7a',
        '& .ReactVirtualized__Table__Grid': {
          outline: 'none'
        }
      },
      header: {
        background: '#546e7a',
        color: '#FFF',
        borderColor: '#fff',
        '& .weekEndDay': {
          background: '#c6efce',
          color: '#006100',
          borderColor: '#fff'
        },
        '& .holiday': {
          color: '#FFF',
          background: '#FCB92E'
        },
        '& .short-day': {
          color: '#FFF',
          background: '#FDD580'
        }
      },
      errorRow: {
        background: '#c6666d!important',
        '&:hover': {
          background: '#e2898f!important'
        }
      },
      activeRow: {
        color: '#FFF!important',
        background: '#7CC981!important',
        '&:hover': {
          background: '#84da8b!important'
        }
      },
      bodyCells: {
        '& .holiday': {
          background: '#FEE8BA',
          color: '#006100',
          borderColor: 'inherit'
        },
        '& .short-day': {
          background: '#FEF1D6',
          color: '#006100',
          borderColor: 'inherit'
        }
      },
      departmentRow: {
        background: '#718e9d',
        color: '#FFF',
        borderColor: '#546e7a!important',
        '&:hover': {
          background: '#90A7B2'
        },
        '& .weekEndDay': {
          background: '#D6F3DC',
          color: '#006100'
        }
      },
      userNameRow: {
        background: '#9db0bb',
        color: '#FFF',
        borderColor: '#546e7a!important',
        borderColorOptional: '#B0C0C8',
        '&:hover': {
          background: '#c0ced3'
        },
        '& .weekEndDay': {
          background: '#D6F3DC',
          color: '#006100'
        }
      },
      userOverUnderTimeRow: {
        background: '#b4c2cb',
        color: '#FFF',
        borderColor: '#546e7a!important',
        '& .weekEndDay': {
          background: '#D6F3DC',
          color: '#006100'
        }
      },
      userPlannedHoursRow: {
        background: primary.light,
        color: '#40545e',
        borderColor: '#9db0bb!important',
        '& .weekEndDay': {
          background: '#E9F8EC',
          color: '#006100'
        }
      },
      userDifferenceRow: {
        background: '#d4dde2',
        color: '#40545e',
        borderColor: '#9db0bb!important',
        '& .weekEndDay': {
          background: '#E9F8EC',
          color: '#006100'
        }
      },
      userAbsencesRow: {
        background: '#d4dde2',
        color: '#40545e',
        borderColor: '#9db0bb!important',
        '& .weekEndDay': {
          background: '#E9F8EC',
          color: '#006100'
        }
      },
      actionGeneralRow: {
        background: '#e2e7eb',
        color: '#333',
        borderColor: '#d4d4d4!important',
        '& .weekEndDay': {
          background: '#F0FBF2',
          color: '#006100'
        }
      },
      actionByTypeRow: {
        background: '#e2e7eb',
        color: '#333',
        borderColor: '#d4d4d4!important',
        '& .weekEndDay': {
          background: '#F0FBF2',
          color: '#006100'
        }
      }
    },
    calendar: {
      color: '#284e86',
      disabledBackground: '#cdcdd5',
      headerBackground: '#607d8b',
      headerBackgroundHover: '#33647b',
      headerColor: '#FFF',
      headerBorder: '#FFF',
      background: '#F7F7F7',
      borderColor: '#607d8b',
      hourBorderColor: '#C1C1C1'
    }
  },
  overrides: {
    MuiFormLabel: {
      root: {
        fontSize: '13px',
        fontWeight: 700,
        lineHeight: 1.5,
        color: defaultText.color
      }
    },
    MuiFormControlLabel: {
      label: {
        color: defaultText.color
      }
    },
    MuiButton: {
      containedPrimary: {
        color: '#FFF',
        '& svg': {
          color: '#FFF'
        },
        '&$disabled': {
          borderColor: 'inherit'
        }
      },
      containedSecondary: {
        color: primary1.dark,
        backgroundColor: primary1.main,
        border: '1px solid #FFF',
        '& svg': {
          color: primary1.dark
        },
        '&:hover': {
          backgroundColor: primary1.main
        },
        '&$disabled': {
          borderColor: 'inherit'
        }
      }
    },
    MuiCheckbox: {
      colorSecondary: {
        color: secondary.main,
        '&$checked': {
          color: secondary.main
        }
      }
    },
    MuiList: {
      root: {
        overflowY: 'auto',
        flex: 1,
        '&::-webkit-scrollbar': {
          width: 5
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 5px grey',
          borderRadius: 3
        },
        '&::-webkit-scrollbar-thumb': {
          background: primary.dark,
          borderRadius: 5
        }
      }
    },
    MuiListItem: {
      root: {
        '&:hover': {
          background: hoverColor
        },
        '&$selected': {
          background: secondary.light,
          color: '#FFF',
          '&:hover': {
            background: secondary.light
          }
        }
      }
    },
    MuiListItemText: {
      primary: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      root: {
        maxWidth: 330,
        overflow: 'hidden'
      }
    }
  },
  typography: {
    useNextVariants: false,
    fontFamily: [
      'Open Sans', 'Roboto', 'sans-serif'
    ].join(',')
  }
};

export default lightBlue;
